import React from 'react';
import PropTypes from 'prop-types';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';

const CardTypeInput = ({ label, name, register, errors, value, language }) => {
    
    return (
        <>
            <label className="dh-form-label font-bold" htmlFor={name}>{label}<span className="sr-only">required</span><span aria-hidden="true">*</span></label>
            <FormControl>
                <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group"
                >
                    <FormControlLabel  {...register(name, {
                        required: `${label}${language.cancelError}`,
                    })} checked={value === "ebt"} name={name} value="ebt" control={<Radio />} label={language.ebtCard} />
                    <FormControlLabel  {...register(name, {
                        required: `${label}${language.cancelError}`,
                    })} name={name} checked={value === "apid"} value="apid" control={<Radio />} label={language.agencyId} />
                </RadioGroup>
            </FormControl>
            {errors.card && (
                <div className="dh-txt-danger"role="alert" aria-live="assertive">
                    {errors.card.message}
                </div>
            )}
        </>
    );
};
CardTypeInput.propTypes = {
    register: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value:PropTypes.string,
    language: PropTypes.object,
};
export default CardTypeInput;
